import { useState, useEffect } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";
import { Building2, FileText, Calendar, BarChart3 } from "lucide-react";

import RecruitmentDashboard from "./RecruitmentDashboard";
import JobOffersList from "./JobOffersList";
import ApplicationsList from "./ApplicationsList";
import InterviewManagement from "./InterviewManagement";

export default function RecruitmentPage({ initialTab = "dashboard" }) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [shouldAutoOpenCreate, setShouldAutoOpenCreate] = useState(false);
  const { user } = useAuth();

  // Update activeTab when initialTab prop changes
  useEffect(() => {
    // Map create-job to jobs tab but track the intention
    if (initialTab === "create-job") {
      setActiveTab("jobs");
      setShouldAutoOpenCreate(true);
    } else {
      setActiveTab(initialTab);
      setShouldAutoOpenCreate(false);
    }
  }, [initialTab]);

  // Check authorization
  const canAccessRecruitment = user?.role === "admin" || user?.role === "rh";

  if (!canAccessRecruitment) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="text-center py-8">
            <Building2 className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Accès restreint
            </h2>
            <p className="text-gray-600">
              Seuls les administrateurs et le personnel RH peuvent accéder au
              module de recrutement.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="dashboard" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            <span className="hidden sm:inline">Tableau de bord</span>
          </TabsTrigger>
          <TabsTrigger value="jobs" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">Offres d'emploi</span>
          </TabsTrigger>
          <TabsTrigger value="applications" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">Candidatures</span>
          </TabsTrigger>
          <TabsTrigger value="interviews" className="flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            <span className="hidden sm:inline">Entretiens</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="space-y-6">
          <RecruitmentDashboard
            onNavigate={(tab) => {
              if (tab === "create-job") {
                setActiveTab("jobs");
                setShouldAutoOpenCreate(true);
              } else {
                setActiveTab(tab);
                setShouldAutoOpenCreate(false);
              }
            }}
          />
        </TabsContent>

        <TabsContent value="jobs" className="space-y-6">
          <JobOffersList
            autoOpenCreate={shouldAutoOpenCreate}
            onModalStateChange={(isOpen) => {
              if (!isOpen) {
                setShouldAutoOpenCreate(false);
              }
            }}
          />
        </TabsContent>

        <TabsContent value="applications" className="space-y-6">
          <ApplicationsList />
        </TabsContent>

        <TabsContent value="interviews" className="space-y-6">
          <InterviewManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}




























